function Error() {
  return (
    <div className="loading">
      <p>Something went wrong. Please contact an admin.</p>
    </div>
  );
}

export { Error };
